module.exports = __webpack_public_path__ + "img/pexels-godisable-jacob-965324.f04bdd4f.jpg";